import { render, staticRenderFns } from "./PrefferedCurrency.htm?vue&type=template&id=403a5289&scoped=true&"
import script from "./PrefferedCurrency.ts?vue&type=script&lang=js&"
export * from "./PrefferedCurrency.ts?vue&type=script&lang=js&"
import style0 from "./PrefferedCurrency.scss?vue&type=style&index=0&id=403a5289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a5289",
  null
  
)

export default component.exports